import React from 'react';
import SafeIcon from '@/common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-gray-300 pt-24 pb-8 border-t border-slate-900">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-20">

          <div className="lg:col-span-5 pr-0 lg:pr-12">
            <img
              src="/images/logo_sueti_fix.png"
              alt="Sueti Tour Logo"
              className="h-12 w-auto mb-8 brightness-0 invert opacity-90"
              onError={(e) => { e.target.src = "https://placehold.co/400x150/0f172a/white?text=Sueti+Tour"; }}
            />
            <p className="text-gray-400 leading-relaxed font-light mb-8 text-sm">
              Menghadirkan pengalaman perjalanan eksklusif dan ibadah yang khusyuk dengan standar pelayanan tertinggi. Komitmen kami adalah kenyamanan dan ketenangan pikiran Anda.
            </p>
            <div className="flex gap-4">
              {['Facebook', 'Instagram', 'Twitter'].map((social) => (
                <a key={social} href="#" className="w-10 h-10 rounded-sm border border-slate-800 flex items-center justify-center hover:bg-accent hover:border-accent hover:text-white transition-all duration-300">
                  <SafeIcon name={social} className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-serif text-lg mb-8 tracking-wide">Navigasi</h4>
            <ul className="space-y-4">
              {['Beranda', 'Layanan', 'Keunggulan', 'Galeri'].map((link) => (
                <li key={link}>
                  <a href={link === 'Beranda' ? '#home' : `#${link.toLowerCase()}`} className="text-gray-400 hover:text-accent transition-colors font-light text-sm flex items-center gap-3">
                    <span className="w-3 h-[1px] bg-slate-700"></span>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-white font-serif text-lg mb-8 tracking-wide">Hubungi Kami</h4>
            <ul className="space-y-6">
              {/*   <li className="flex items-start gap-4 group">
                <SafeIcon name="MapPin" className="text-accent w-5 h-5 mt-1 opacity-70 group-hover:opacity-100 transition-opacity shrink-0" />
                <span className="text-gray-400 font-light text-sm leading-relaxed">
                  Arcade Business Center 8th Floor Unit 8-05<br />
                  Jl. Pantai Indah Utara 2 Kav. C1, Desa/Kelurahan Kapuk Muara<br />
                  Kec. Penjaringan, Kota Adm. Jakarta Utara<br />
                  Provinsi DKI Jakarta, Kode Pos 14460
                </span>
              </li> */}
              <li className="flex items-center gap-4 group">
                <SafeIcon name="Mail" className="text-accent w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity shrink-0" />
                <span className="text-gray-400 font-light text-sm">cs@suetitour.com</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-slate-800/50 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-xs font-light tracking-wide">
          <p>&copy; Sueti Tour & Travel. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-accent transition-colors">Kebijakan Privasi</a>
            <a href="#" className="hover:text-accent transition-colors">Syarat & Ketentuan</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;